import { useCallback } from 'react';
import { en } from '../locales/en';
import { AppError, ErrorCode } from '../types/errors/errors';

export function useLocalizedErrorMessage() {
  return useCallback((error: unknown): string => {
    if (!(error instanceof AppError)) {
      return en.errors.unknown;
    }

    switch (error.code) {
      case ErrorCode.HTTP_REQUEST_FAILED:
        return en.errors.httpRequestFailed;
      case ErrorCode.HTTP_BAD_REQUEST:
        return en.errors.httpBadRequest;
      case ErrorCode.HTTP_UNAUTHORIZED:
        return en.errors.httpUnauthorized;
      case ErrorCode.HTTP_FORBIDDEN:
        return en.errors.httpForbidden;
      case ErrorCode.HTTP_NOT_FOUND:
        return en.errors.httpNotFound;
      case ErrorCode.HTTP_INTERNAL_SERVER_ERROR:
        return en.errors.httpInternalServerError;
      case ErrorCode.HTTP_BAD_GATEWAY:
        return en.errors.httpBadGateway;
      case ErrorCode.HTTP_SERVICE_UNAVAILABLE:
        return en.errors.httpServiceUnavailable;
      case ErrorCode.HTTP_GATEWAY_TIMEOUT:
        return en.errors.httpGatewayTimeout;
      case ErrorCode.JRPC_RESPONSE_ERROR:
        return (error.params['errorMessage'] as string) ?? en.errors.unknown;
      case ErrorCode.AUTH_OKTA_CALLBACK_MISSING_CODE:
        return en.errors.authOktaCallbackMissingCode;
      case ErrorCode.AUTH_OKTA_CALLBACK_MISSING_REDIRECT_URI:
        return en.errors.authOktaCallbackMissingRedirectUri;
      case ErrorCode.AUTH_OKTA_CALLBACK_MISSING_PENDING_GCS_ID:
        return en.errors.authOktaCallbackMissingPendingGcsId;
      case ErrorCode.AUTH_OKTA_CALLBACK_GCS_CONFIG_NOT_FOUND:
        return en.errors.authOktaCallbackGcsConfigNotFound;
      case ErrorCode.MISSION_NOT_FOUND:
        return en.errors.missionNotFound;
      case ErrorCode.UNKNOWN:
      default:
        return en.errors.unknown;
    }
  }, []);
}
